import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { ToastContainer } from "react-bootstrap";
import Footer from "./Footer";

export default function DashboardLayout() {
  const location = useLocation();
  const token = sessionStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return (
    <div className="dashboard-container">
      <Sidebar />
      <Outlet /> {/* This is where nested routes will be rendered */}
      <Footer />
      <ToastContainer />
    </div>
  );
}
